export const TABLE = {
  CSV: 1,
  BACKEND: 2,
};

export const columnTitles = [
  {
    title: 'Tiêu đề',
    dataIndex: 'title',
  },
  {
    title: 'Slug',
    dataIndex: 'slug',
  },
  {
    title: 'Nội dung',
    dataIndex: 'content',
  },
  {
    title: 'Ngôn ngữ',
    dataIndex: 'language',
  },
  {
    title: 'Trạng thái',
    dataIndex: 'published',
  },
];
